import { Col } from 'reactstrap'
import './ProductCard.scss'

const ProductCard = () =>
  <Col md="4" className="product-card">
    <div className="product-card--container" />
  </Col>

export default ProductCard
